import axios from 'axios';
import {AUTHENTICATED, removeLocalStorageItem} from "../../utils/storage-utils";


const service = axios.create( {
    baseURL : process.env.REACT_APP_PUBLIC_URL,
    withCredentials:true,
    headers: {
        "Access-Control-Allow-Origin": "http://127.0.0.1:3000",

    }
})


    service.interceptors.response.use( ( response ) => {
            if ( response && (response.status === 302 || response.status === 403)  ) {
                window.location.href ="/supplyencodingsvc/?timeout=true";
            }   
            return response;
        }, ( error ) => {
            /*
            if(!error.response) {
                window.location.href ="/supplyencodingsvc/?timeout=true";  
                return Promise.reject(error); 
            }
            if ( error?.response && error?.response?.status === 302 || error?.response?.status === 403  ) {
                window.location.href ="/supplyencodingsvc/?timeout=true";
                return Promise.reject(error);
            } */
            if (error.request) {
                if( error.request.status !== 401 && error.request.status !== 400 && error.request.status !== 504 && error.request.status !== 500 && error.request.status !== 404) {
                    // removeLocalStorageItem(AUTHENTICATED);
                    window.location.href ="/supplyencodingsvc/?state=Error";
                }
                return Promise.reject(error);
            }
        });
    export default service;
